import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.project.detail');
import { OnInit, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let WizRoute: any;
declare let wiz: any;

@Component({
    selector: 'wiz-page-project-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.project.detail/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageProjectDetailComponent implements OnInit {
    public project: any = null;
    public documents: any[] = [];
    public drawings: any[] = [];
    public facilities: any[] = [];
    public id: string = '';

    public showDocumentModal: boolean = false;
    public showDrawingModal: boolean = false;
    public showFacilityModal: boolean = false;
    public showEditModal: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( CDR)  public ref: CDR) { }

    public async ngOnInit() {
        await this.service.init(this);
        this.id = WizRoute.segment.id || '';
        await this.load();
        await this.service.loading.hide();
        await this.service.render();
    }

    public async load() {
        const { code, data } = await wiz.call('detail', { id: this.id });
        if (code === 200) {
            this.project = data.project || null;
            this.documents = data.documents || [];
            this.drawings = data.drawings || [];
            this.facilities = data.facilities || [];
        } else {
            await this.service.alert.show({
                title: '오류',
                message: '용역 정보를 불러올 수 없습니다.',
                status: 'error',
                action: '확인',
                cancel: false
            });
            this.service.href('/project/list');
        }
        await this.service.render();
    }

    public calculateDays(): number {
        if (!this.project?.start_date || !this.project?.end_date) return 0;
        const diff = new Date(this.project.end_date).getTime() - new Date(this.project.start_date).getTime();
        return Math.ceil(diff / (1000 * 60 * 60 * 24)) + 1;
    }

    public getParticipantCount(): number {
        if (!this.project?.participants) return 0;
        return this.project.participants.split(',').filter((p: string) => p.trim()).length;
    }

    public formatDate(dateStr: string): string {
        if (!dateStr) return '';
        return dateStr.split(' ')[0];
    }

    public formatCurrency(value: number | string): string {
        const numericValue = Number(String(value || '').replace(/[^0-9]/g, ''));
        if (!numericValue) return '0';
        return numericValue.toLocaleString('ko-KR');
    }

    private getProjectCategories(): string[] {
        const labels = String(this.project?.category || '')
            .split(',')
            .map((item: string) => item.trim())
            .filter((item: string) => !!item)
            .map((item: string) => (item === '전체' || item === '기타(연구소)') ? '기타' : item);
        return Array.from(new Set(labels));
    }

    public getProjectCategoryLabel(): string {
        const categories = this.getProjectCategories();
        return categories.length > 0 ? categories.join(', ') : '미지정';
    }

    public getProjectCategoryIconClass(): string {
        const categories = this.getProjectCategories();
        if (categories.length > 1) return 'bg-gradient-to-br from-sky-100 to-cyan-100';
        if (categories.includes('건축')) return 'bg-gradient-to-br from-amber-100 to-orange-100';
        if (categories.includes('토목')) return 'bg-gradient-to-br from-cyan-100 to-blue-100';
        return 'bg-gradient-to-br from-slate-100 to-gray-100';
    }

    public getProjectCategoryIcon(): string {
        const categories = this.getProjectCategories();
        if (categories.length > 1) return 'fa-solid fa-layer-group text-sky-600';
        if (categories.includes('건축')) return 'fa-solid fa-building text-amber-600';
        if (categories.includes('토목')) return 'fa-solid fa-road text-cyan-600';
        return 'fa-solid fa-tag text-slate-500';
    }

    public getSupplyAmount(): number {
        const contractAmount = Number(this.project?.contract_amount || 0);
        if (!contractAmount) return 0;
        return Math.floor(contractAmount / 1.1);
    }

    private triggerDownload(url: string, filename: string) {
        const link = document.createElement('a');
        link.href = url;
        link.download = filename || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    public goBack() {
        this.service.href('/project/list');
    }

    // ── Contract Document Modal ──
    public async openDocumentModal() {
        this.showDocumentModal = true;
        await this.service.render();
    }

    public async closeDocumentModal() {
        this.showDocumentModal = false;
        await this.service.render();
    }

    public async deleteDocument(document: any) {
        await this.service.loading.show();
        const { code } = await wiz.call('delete_document', { id: document.id });
        await this.service.loading.hide();
        if (code === 200) await this.load();
    }

    public downloadDocument(document: any) {
        this.triggerDownload(wiz.url('download_document') + '?id=' + document.id, document.filename || 'download');
    }

    // ── Drawing Modal ──
    public async openDrawingModal() {
        this.showDrawingModal = true;
        await this.service.render();
    }

    public async closeDrawingModal() {
        this.showDrawingModal = false;
        await this.service.render();
    }

    public async deleteDrawing(drawing: any) {
        await this.service.loading.show();
        const { code } = await wiz.call('delete_drawing', { id: drawing.id });
        await this.service.loading.hide();
        if (code === 200) await this.load();
    }

    public downloadDrawing(drawing: any) {
        this.triggerDownload(wiz.url('download') + '?id=' + drawing.id, drawing.filename || 'download');
    }

    // ── Facility Modal ──
    public async openFacilityModal() {
        this.showFacilityModal = true;
        await this.service.render();
    }

    public async closeFacilityModal() {
        this.showFacilityModal = false;
        await this.service.render();
    }

    public async deleteFacility(facility: any) {
        await this.service.loading.show();
        const { code } = await wiz.call('delete_facility', { id: facility.id });
        await this.service.loading.hide();
        if (code === 200) await this.load();
    }

    // ── Project Edit Modal ──
    public async openEditModal() {
        this.showEditModal = true;
        await this.service.render();
    }

    public async closeEditModal(success: boolean) {
        this.showEditModal = false;
        if (success) {
            await this.load();
        }
        await this.service.render();
    }
}

export default PageProjectDetailComponent;